import React from 'react';
import user from '../Auth/user';
import firebase from '../firebase';
import compose from '../compose';
import { translate } from 'react-i18next';
import {Card, CardText} from 'material-ui/Card';
import {
  Table,
  TableBody,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';
import {Toolbar, ToolbarGroup, ToolbarTitle} from 'material-ui/Toolbar';
import LoadingIndicator from '../Navigation/LoadingIndicator';
import PriceDialog from '../Stand/PriceDialog';
import AddStockDialog from '../Stand/AddStockDialog';

class ProductsPrices extends React.Component {
  constructor(props) {
    super(props);
    this.initialState =  {
      productKey: null,
      productStands: [],
      loadingIndicator: 'flex',
      priceDialog: false,
      addStockDialog: false,
      dialogProduct: null
    };

    this.state = {
      ...this.initialState
    };
  }
  componentDidMount = () => {
    const {firebase, productKey} = this.props;
    const {shopkeeperId} = this.props.user;

    if (!productKey || !shopkeeperId) return;

    this.setState({productKey});

    firebase.database().ref(`shopkeepers/${shopkeeperId}/standsList/`)
      .orderByChild('name')
      .once('value', (stands) => {
        stands.forEach((stand) => {
          firebase.database().ref(`shopkeepers/${shopkeeperId}/stands/${stand.key}/products/${productKey}`)
            .once('value', (data) => {
              if (!data.exists()) return;

              const productStand = {
                key: data.key,
                standName: stand.val().name,
                standKey: stand.key,
                ...data.val()
              };
              const productStands = this.state.productStands.slice();
              productStands.push(productStand);
              this.setState({productStands});
            }
            );
        });
      }).then(() => {
        this.setState({loadingIndicator: 'none'});
      });

  }
  handlePriceDialogClose = (price) => {
    if (price) {
      const productStands = this.state.productStands.slice();
      const index = productStands.findIndex((item) => (item.standKey === this.state.dialogStandKey));
      productStands[index].price = price;
      this.setState({productStands});
    }

    this.setState({priceDialog: false});
  }
  handlePriceDialogOpen = () => {
    this.setState({priceDialog: true});
  }
  handleAddStockClose = (totalCount) => {
    if (totalCount) {
      const productStands = this.state.productStands.slice();
      const index = productStands.findIndex((item) => (item.standKey === this.state.dialogStandKey));
      productStands[index].totalCount = totalCount;
      this.setState({productStands});
    }

    this.setState({addStockDialog: false});
  }
  handleAddStockOpen = () => {
    this.setState({addStockDialog: true});
  }
  handleCellClick = (row,column, event) => {
    var rect = event.target.getBoundingClientRect();

    const isPriceColumn = column === 1;
    const isStockColumn = column === 2;
    const isHeaderRow = row === 0;
    const isEditableCell = rect.height < 20;

    if ((!isPriceColumn && !isStockColumn) || isHeaderRow || !isEditableCell) return;

    const eventPosition = this.clickPosition(rect);

    if (isPriceColumn) {
      this.setState({dialogProduct: this.state.productStands[row-1],
        priceDialog: true,
        eventPosition,
        dialogStandKey: this.state.productStands[row-1].standKey,
        dialogStandName: this.state.productStands[row-1].standName});
    } else {
      this.setState({dialogProduct: this.state.productStands[row-1],
        addStockDialog: true,
        eventPosition,
        dialogStandKey: this.state.productStands[row-1].standKey,
        dialogStandName: this.state.productStands[row-1].standName});
    }
  }
  clickPosition = (rect) => {
    const maxDialogWidth = 310;
    const maxDialogHeight = 330;
    const dialogHeight = 300;
    const topBarHeight = 64;

    let x = 0;
    if (rect.left + maxDialogWidth > window.innerWidth) {
      x = window.innerWidth - maxDialogWidth;
    } else if (rect.left - maxDialogWidth > 0) {
      x = rect.left;
    }

    let y = 0;
    if (rect.top + dialogHeight > window.innerHeight) {
      y = window.innerHeight - maxDialogHeight;
    } else if (rect.top - topBarHeight > 0) {
      y = rect.top - topBarHeight;
    }

    let eventPosition = {x, y};

    return eventPosition;
  }
  render() {
    const {t} = this.props;
    const productStands =
    this.state.productStands.map((productStand) => (
      <TableRow key={productStand.standKey}>
        <TableRowColumn style={{whiteSpace: 'normal', wordWrap: 'break-word'}}>
          {productStand.standName}
        </TableRowColumn>
        <TableRowColumn style={{width: '100px'}}>
          <span style={{fontFamily: 'Roboto Mono, monospace', textAlign: 'right', borderBottom: '1px solid #BDBDBD', display: 'block', cursor: 'pointer'}}>
            {Number(productStand.price).toFixed(2) + ' €'}
          </span>
        </TableRowColumn>
        <TableRowColumn style={{width: '100px'}}>
          <span style={{fontFamily: 'Roboto Mono, monospace', textAlign: 'right', borderBottom: '1px solid #BDBDBD', display: 'block', cursor: 'pointer'}}>
            {productStand.totalCount | 0}
          </span>
        </TableRowColumn>
      </TableRow>
    ));
    return (
      <Card className='cardStyle'>
        <Toolbar>
          <ToolbarGroup>
            <ToolbarTitle text={t('product.productStands')} />
          </ToolbarGroup>
        </Toolbar>
        <CardText>
          <Table style={{tableLayout: 'auto'}} onCellClick={this.handleCellClick}>
            <TableBody displayRowCheckbox={false} >
              <TableRow>
                <TableRowColumn style={{color: '#9e9e9e'}}>{t('stand.stand')}</TableRowColumn>
                <TableRowColumn style={{textAlign: 'center', color: '#9e9e9e', width: '100px'}}>{t('price')}</TableRowColumn>
                <TableRowColumn style={{textAlign: 'center', color: '#9e9e9e', width: '100px'}}>{t('stock')}</TableRowColumn>
              </TableRow>
              {productStands}
            </TableBody>
          </Table>
          <LoadingIndicator display={this.state.loadingIndicator} />
        </CardText>
        <PriceDialog
          open={this.state.priceDialog}
          handleClose={this.handlePriceDialogClose}
          product={this.state.dialogProduct}
          standKey={this.state.dialogStandKey}
          standName={this.state.dialogStandName}
          eventPosition={this.state.eventPosition}/>
        <AddStockDialog
          open={this.state.addStockDialog}
          handleClose={this.handleAddStockClose}
          product={this.state.dialogProduct}
          standKey={this.state.dialogStandKey}
          standName={this.state.dialogStandName}
          eventPosition={this.state.eventPosition}/>
      </Card>

    );
  }
}

const enhance = compose(translate(), firebase, user);

export default enhance(ProductsPrices);



// WEBPACK FOOTER //
// ./src/Product/ProductPrices.js